import useStore from "../../../store"
import { useEffect } from "react"
import UnitInfo from "./UnitInfo"
import MakePayment from "../MakePayment/MakePayment"
import Spinner from "../../common/Spinner"
import PendingNAP from "./PendingNAP"
import UnitWarning from "./UnitWarning"
import Breadcrumbs from "../../common/Breadcrumbs"
import { useIsMobile } from "../../../hooks/useIsMobile"
import TransferPageBody from "../TransferPage/TransferPageBody"
import TransferHeader from "../TransferPage/TransferHeader"
import useUserType from "../../../hooks/useUserType"
import EmployeeUnitPageBody from "./EmployeeUnitPageBody"
import UnitWarningContainer from "./UnitWarningContainer"
import { useTranslation } from "react-i18next"
import AppliedCouponsBanner from "./AppliedCouponsBanner"

export default function UnitPageBody({ unitId }) {
  const { unit, fetchUnit } = useStore()
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { isEmployee } = useUserType()

  useEffect(() => {
    fetchUnit(unitId)
  }, [unitId])

  if (isEmployee) {
    return <EmployeeUnitPageBody unitId={unitId} />
  }

  return(
    <>
      {isMobile && isEmployee &&
        <Breadcrumbs/>
      }
      {unit && unit.id == unitId ?
        <div className="flex flex-col items-start w-full mt-3">
          <div className="font-bold ml-2 mb-4">
            <p className="text-lg text-grey-300">{unit.attributes.year} {unit.attributes.make}</p>
            <p className= 'text-4xl text-grey-100'>{unit.attributes.model}</p>
            {isEmployee &&
              <div className="flex items-center">
                {unit.attributes['dealer-name']}
              </div>
            }
          </div>
          <div className="flex flex-col items-center w-full">
            <AppliedCouponsBanner appliedCoupons={unit.attributes['applied-coupons']} />
            {unit.attributes.transportation &&
              <UnitWarningContainer colorStyles="text-yellow border-yellow">
                <span>{t("Transportation Unit")}</span>
              </UnitWarningContainer>
            }
            <UnitWarning unit={unit} />
            {unit.attributes.status === 'Pending' &&
              <PendingNAP />
            }
          </div>
          <UnitInfo />
          {unit.attributes['ach-initiated']?
            <div className="w-full border-t-2 border-grey-700 bg-grey-900">
              <TransferHeader/>
              <TransferPageBody transferId={unit.attributes['pending-transfer-id']} showAltData={false}/>
            </div>
          :
            <MakePayment/>
          }
        </div>
      :
        <div className="flex items-center justify-center h-full">
          <Spinner />
        </div>
      }
    </>
  )
}
